import { render, staticRenderFns } from "./TaskTags.vue?vue&type=template&id=36cfb002&"
import script from "./TaskTags.vue?vue&type=script&lang=js&"
export * from "./TaskTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports